import { jsx, Fragment } from 'react/jsx-runtime';
import { PrimaryColors, ThemeLightValues, ThemeDarkValues } from '@picsart/design-system/foundation/colors';
import { createUseStyles } from 'react-jss';
import { canHover, canTouch } from '@picsart/design-system/foundation/styleHelpers';
import { Easing } from '@picsart/design-system/foundation/easing';
import { Timings } from '@picsart/design-system/foundation/timings';
import { useEffect } from 'react';
import { useFoundation } from '@picsart/design-system/foundation/initFoundation';

var _a;
var useDefaultBoilerplate = createUseStyles({
  '@global': {
    ':root': {},
    html: {
      '&.desktop': {
        minWidth: 1024
      }
    },
    body: {
      '&.no-scroll': {
        height: '100vh',
        overflow: 'hidden'
      },
      '& header': {
        zIndex: 3
      },
      '& footer': {
        zIndex: 3
      }
    },
    a: {
      textDecoration: 'none',
      '&.korea-link': {
        color: "".concat(PrimaryColors.base["default"], " !important")
      },
      '&.inline-link': (_a = {
        display: 'contents',
        color: PrimaryColors.base["default"],
        transition: "color ".concat(Timings["default"], " ").concat(Easing.easeInOut)
      }, _a[canHover] = {
        '&:hover': {
          color: PrimaryColors.base.action
        }
      }, _a[canTouch] = {
        '&:active': {
          color: PrimaryColors.base.action
        }
      }, _a)
    },
    span: {
      '&.colored': {
        color: PrimaryColors.base["default"]
      }
    }
  }
}, {
  name: 'default-boilerplate'
});

var ThemeProvider = function ThemeProvider(_a) {
  var children = _a.children;
  useDefaultBoilerplate();
  useChangeColors();
  return jsx(Fragment, {
    children: children
  });
};

var HTMLColorModeClassnames;
(function (HTMLColorModeClassnames) {
  HTMLColorModeClassnames["Dark"] = "dark";
  HTMLColorModeClassnames["Light"] = "light";
})(HTMLColorModeClassnames || (HTMLColorModeClassnames = {}));
var StyleTagClassnames;
(function (StyleTagClassnames) {
  StyleTagClassnames["Typographies"] = "growth-rc-typographies";
  StyleTagClassnames["Resetters"] = "growth-rc-resetters";
  StyleTagClassnames["Radiuses"] = "growth-rc-radiuses";
  StyleTagClassnames["Spacings"] = "growth-rc-spacings";
  StyleTagClassnames["Timings"] = "growth-rc-timings";
  StyleTagClassnames["Easings"] = "growth-rc-easings";
  StyleTagClassnames["Colors"] = "growth-rc-colors";
})(StyleTagClassnames || (StyleTagClassnames = {}));

var updateHtmlClassName = function updateHtmlClassName(className) {
  var htmlElement = document.querySelectorAll('html')[0];
  Object.values(HTMLColorModeClassnames).forEach(function (el) {
    htmlElement.classList.remove(el);
  });
  htmlElement.classList.add(className);
};
var toggleHtmlClassName = function toggleHtmlClassName(isDarkModeEnabled) {
  return updateHtmlClassName(isDarkModeEnabled ? HTMLColorModeClassnames.Dark : HTMLColorModeClassnames.Light);
};

var useChangeColors = function useChangeColors(isDark) {
  if (isDark === void 0) {
    isDark = false;
  }
  var themes = [{
    key: HTMLColorModeClassnames.Light,
    value: ThemeLightValues,
    selected: !isDark
  }, {
    key: HTMLColorModeClassnames.Dark,
    value: ThemeDarkValues,
    selected: isDark
  }];
  useFoundation({
    themes: themes
  });
  useEffect(function () {
    toggleHtmlClassName(isDark);
  }, [isDark]);
};

var getColor = function getColor(key) {
  return getComputedStyle(document.documentElement).getPropertyValue(key);
};

export { ThemeProvider, getColor, toggleHtmlClassName, useChangeColors };
//# sourceMappingURL=index.js.map
